
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerItems/policies/refundPolicy",
      function () {
        return require("private-next-pages/footerItems/policies/refundPolicy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerItems/policies/refundPolicy"])
      });
    }
  